var _path, _ellipse, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValidationLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 303,
    viewBox: "0 0 200 303",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 135L169 135V100C169 61.8924 138.108 31 100 31C61.8923 31 31 61.8923 31 100V135ZM200 135V203C200 258.228 155.228 303 100 303C51.6751 303 11.3563 268.722 2.03164 223.153C0.699555 216.644 0 209.904 0 203V135V100C0 44.7715 44.7715 0 100 0C155.228 0 200 44.7715 200 100V135Z",
    fill: "#91A0E2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.5,
    cy: 209.5,
    rx: 17.5,
    ry: 17.5,
    fill: "#1B1B1B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 95.7266,
    y: 221.697,
    width: 9.54545,
    height: 26.5151,
    rx: 3.18182,
    fill: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169 101.296H200V100H169V101.296ZM200 106.481H169V103.889H200V106.481ZM200 135H169V109.074H200V135Z",
    fill: "url(#paint0_linear_2012_18178)",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 110.926H31V110H0V110.926ZM31 114.63H0V112.778H31V114.63ZM31 135H0V116.481H31V135Z",
    fill: "url(#paint1_linear_2012_18178)",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2012_18178",
    x1: 186,
    y1: 95.5,
    x2: 186,
    y2: 110.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2012_18178",
    x1: 17,
    y1: 106.786,
    x2: 17,
    y2: 117.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationLock);
export default __webpack_public_path__ + "static/media/validation-lock.abadc7e17b757ec7481d3b41b32d0a09.svg";
export { ForwardRef as ReactComponent };